module.exports = __webpack_public_path__ + "static/covid-19-1095d7f017d7ad91b136713a31dc767d.png";